import React, { useEffect, useState } from "react";

import "./ProjectWebDevSingle.css";

import { motion } from "framer-motion";
import TopBar from "../../../components/TopBar/TopBar";
import Navbar from "../../../components/Navbar/Navbar";
import { client } from "../../../client";
import { Link } from "react-router-dom";
import Button from "../../../components/Button/Button";
import TopBarSingleProject from "../../../components/TopBar/TopBarSingleProject";

const ProjectWebDev = () => {
  // add this is all pages to reset the Scroll position

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {};

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // this is for page title

  useEffect(() => {
    // Set the page title when the component mounts
    document.title = "Web Development Project - Shreeyash Parsawar | Portfolio";
  }, []);

  // api featch data

  const [projectsectionwevdev, setProjectsectionwevdev] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = `*[_type == "projects"]{
            id,
            slug,
            projectname,
            projectshortdesc,
            projectimg{
              asset->{
                  _id,
                  url
              }
          }
                
          }| order(id desc) `;

    client.fetch(query).then((data) => {
      setProjectsectionwevdev(data);
      setLoading(false);
    });
  }, []);

  if (!projectsectionwevdev) return <div className="spinner"></div>;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 3 }}
    >
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <section className="sectionProjectWevdev pb-5">
          {/* <TopBar /> */}

          <TopBarSingleProject/>
          <div className="container-fluid ">
            <div className="row">
              {/* ---------------------------------------------------------------------------- */}

              {/* Project  section  */}

              <div className="container-fluid">
                <div className="row">
                  {projectsectionwevdev && (
                    <div className="col-lg-12 mt-5 ">
                      <h1  className="text-capitalize  fontpara">
                        I've completed {projectsectionwevdev.length} main coding
                        projects, and many more are coming soon....
                      </h1>
                    </div>
                  )}
                </div>
              </div>

              {projectsectionwevdev &&
                projectsectionwevdev.map((pdata, index) => (
                  <div className="container knowledge_div my-5">
                    <div
                      className={`row ${
                        index % 2 === 0
                          ? "flex-row-reverse text-center"
                          : "text-center"
                      }`}
                    >
                      {/* Project Detials section  */}

                      <div className="col-lg-6 col-md-6 text-center">
                        <img
                          src={pdata.projectimg.asset.url}
                          className="img-fluid"
                          alt=""
                          style={{
                            borderRadius: "41px",
                          }}
                        />
                      </div>

                      {/* Project Detials section  */}

                      {/* project photo section  */}

                      <div className="col-lg-6 col-md-6 d-flex flex-column">
                        <div className="">
                          <h1 className="project_title">{pdata.projectname}</h1>
                          <p className="project_desc" >
                            {pdata.projectshortdesc
                              ? pdata.projectshortdesc
                              : "No Short Description is Given"}
                          </p>
                        </div>

                        <div className="mt-auto text-center">
                          <Link
                            to={"/project/projectwebdev/" + pdata.slug.current}
                            key={pdata.slug.current}
                          >
                            <Button title="Show Detail's" />
                          </Link>
                        </div>
                      </div>

                      {/* project photo section  */}
                    </div>
                  </div>
                ))}
              {/*Project  section  */}

              {/* ---------------------------------------------------------------------------- */}
            </div>
          </div>

          {/* <Navbar /> */}
        </section>
      )}
    </motion.div>
  );
};

export default ProjectWebDev;
